import { Area, AreaContent } from "../../useAreas/areas/types";
import hero from "../../../../assets/image/areas/hero/familienrecht.webp";

const data: AreaContent = {
  id: Area.FAMILIENRECHT,
  hero: hero,
  content: [
    "Das Familienrecht umfasst nicht nur das Eherecht vor und nach der Ehe, sondern auch Fragen zum Umgangsrecht, Sorgerecht, zu nichtehelichen Lebensgemeinschaften und eingetragenen Lebenspartnerschaften. Daneben gehören auch Regelungen zur Betreuung, Vormundschaft und Pflegschaft zum familienrechtlichen Bereich.",
    "Wir stehen Ihnen gestaltend und beratend zur Seite, insbesondere bei:",
    [
      "der Gestaltung von Eheverträgen, zum Beispiel zur Zugewinngemeinschaft, Gütertrennung oder Gütergemeinschaft",
      "der Durchführung von Scheidungen",
      "der Regelung des Zugewinnausgleichs und des Versorgungsausgleichs",
      "der Durchsetzung des Umgangsrechts, Sorgerechts und Aufenthaltsbestimmungsrechts",
      "der Durchsetzung des Ehegatten- und Kindesunterhalts unter Berücksichtigung der Düsseldorfer Tabelle",
    ],
  ],
  bullets: [
    "Gestaltung von Eheverträgen",
    "Scheidung",
    "Zugewinnausgleich",
    "Versorgungsausgleich",
    "Umgangsrecht",
    "Sorgerecht",
    "Aufenthaltsbestimmungsrecht",
    "Ehegattenunterhalt",
    "Kindesunterhalt",
    "Düsseldorfer Tabelle",
  ],
  more: [],
};

export default data;
